export const CREATE_EXPENSE = "CREATE_EXPENSE";
export const FETCH_EXPENSES = "FETCH_EXPENSES";
export const FETCH_EXPENSE = "FETCH_EXPENSE";
export const EDIT_EXPENSE = "EDIT_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
